import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Loads the pulse when selected date (Last Week/Month/Quarter) is changed
 */
export const loadOnDateChange = store.effects.create((feature: Feature) =>
  feature.actions.setDate
    .observe()
    .pipe(rxjs.map(action => feature.actions.load.from(action).create())),
)
